// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-window-item[data-v-740c05d8]{height:80vh;overflow-y:scroll;overflow-x:hidden}.subtitle[data-v-740c05d8],.v-card>h2[data-v-740c05d8]{color:#1e88e5;font-weight:700}a[data-v-740c05d8]{text-decoration:none}.right[data-v-740c05d8]{float:right}.v-tabs-items.full-height-tab .v-window-item[data-v-740c05d8]{height:calc(100vh - 160px);width:100%;overflow-y:auto;overflow-x:hidden}", ""]);
// Exports
module.exports = exports;
